import { Directive, HostListener, input, OnDestroy, OnInit, output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
    selector: '[stbyThrottleClick]',
    standalone: true,
})
export class ThrottleClickDirective implements OnInit, OnDestroy {
    readonly throttleTime = input(500);
    readonly throttledClick = output<PointerEvent>();

    private clicks = new Subject<PointerEvent>();
    private subscription: Subscription;

    ngOnInit() {
        this.subscription = this.clicks
            .pipe(throttleTime(this.throttleTime()))
            .subscribe((e) => this.emitThrottledClick(e));
    }

    emitThrottledClick(event: PointerEvent) {
        this.throttledClick.emit(event);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    @HostListener('click', ['$event'])
    clickEvent(event: PointerEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }
}
